import { getLocale } from "../runtime";

const sv_eucountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Europa`
};

const eucountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_eucountry(inputs)
	return "euCountry";
};

export { eucountry as "euCountry" };